/* -------------------------------------------------------------------
  出荷日計算・土日祝日お盆ＣＬＥＡＲ　ver
-------------------------------------------------------------------- */
//'12 29 2018 11:00:00 GMT+0900'
thisDay = new Date();
timeStamp = thisDay.getTime();
myyear  = thisDay.getMonth();
myMonth = thisDay.getMonth() + 1 ;
myDate  = thisDay.getDate();
myHours = thisDay.getHours();
myDay   = thisDay.getDay();
myWeekTbl = new Array( "日","月","火","水","木","金","土"  );

function isHoliday (year, month, date, nday) {
  nofw    = Math.floor((date - 1) / 7) + 1;
  shunbun = Math.floor(20.8431+0.242194*(year-1980)-Math.floor((year-1980)/4));
  syubun  = Math.floor(23.2488+0.242194*(year-1980)-Math.floor((year-1980)/4));

  //振替休日は下記に登録しない
  
  if (month ==  1 && date == 1)                { return 1; } // 1月正月休み
  if (month ==  1 && date == 2)                { return 1; } // 1月正月休み
  //if (month ==  1 && date == 3)                { return 1; } // 1月正月休み
  //if (month ==  1 && date == 4)                { return 1; } // 1月正月休み
  // if (month ==  1 && date == 5)                { return 1; } // 1月正月休み

  
  if (month ==  1 && nday ==  1 && nofw ==  2) { return 1; } // 成人の日
  if (month ==  2 && date == 11)               { return 1; } // 建国記念の日
  if (month == 2 && date == 23)                { return 1; } // 天皇誕生日
  if (month ==  3 && date == shunbun)          { return 1; } // 春分の日
  if (month ==  4 && date == 29)               { return 1; } // 昭和の日

  if (month ==  5 && date >=  3 && date <=  5) { return 1; } // 憲法記念日～こどもの日
  
  
  if (month ==  7 && nday ==  1 && nofw ==  3) { return 1; } // 海の日

  if (month == 8 && date == 11) { return 1; }               //山の日
  if (month == 8 && date == 13) { return 1; }  // アジアンライフお盆休み
  if (month == 8 && date == 14) { return 1; }  // アジアンライフお盆休み
  if (month == 8 && date == 15) { return 1; }  // アジアンライフお盆休み
  
  if (month ==  9 && nday ==  1 && nofw ==  3) { return 1; } // 敬老の日
  if (month ==  9 && date == syubun)           { return 1; } // 秋分の日

  if (month == 10 && date == 14) { return 1; } // スポーツの日

  if (month == 11 && date ==  3)               { return 1; } // 文化の日
  if (month == 11 && date == 23)               { return 1; } // 勤労感謝の日

  if (month == 12 && date == 27)               { return 1; } // 12月正月休み
  if (month == 12 && date == 28)               { return 1; } // 12月正月休み
  if (month == 12 && date == 29)               { return 1; } // 12月正月休み
  if (month == 12 && date == 30)               { return 1; } // 12月正月休み
  if (month == 12 && date == 31)               { return 1; } // 12月正月休み

  if (nday  ==  0)                             { return 2; } // 日曜
  if (nday  ==  6)                             { return 2; } // 土曜
  /*############################################################################
	monthで月の指定。　例）１月ならば　month == 1
	dateで月の指定。　例）１日ならば　date == 1
　　############################################################################*/
  

  
  
  return 0;
}

function dispDate2W (n, h, d) {
  return dispDate2(n, h, 2, d);//●月▼日発送・・・の部分。１２時超えると日付が変わる。
}
function dispDate2 (n, h, w, d) {
  var i = 0;
  while (i <= n) {
    thisDay.setTime(timeStamp + (1000*60*60*24 * i));
    myYear2  = thisDay.getFullYear();
    myMonth2 = thisDay.getMonth() + 1;
    myDate2  = thisDay.getDate();
    myDay2   = thisDay.getDay();
    if (isHoliday(myYear2,myMonth2,myDate2,myDay2) == 0 && i == 0 && h <= myHours) { n++; }  // 翌日扱い
    if (isHoliday(myYear2,myMonth2,myDate2,myDay2) >= 1){ n++; }  // 休日
    if (isHoliday(myYear2,myMonth2,myDate2,myDay2) == 1 && myDay2 == 0){ n++; }  // 振替休日
    i++;
  }

  if(d == 0){
    myMonth2 = '0'+ myMonth2;
    myMonth2 = myMonth2.slice(-2);
    myDate2  = '0' + myDate2;
    myDate2  = myDate2.slice(-2);
    return dateFormat(myMonth2,myDate2,myYear2,w);
  }else{
    otodoke = new Date(myYear2,myMonth2-1,myDate2,00,00)
    otodoke.setDate(parseInt(otodoke.getDate()) + parseInt(d));
    
    myYear2  = otodoke.getFullYear();
    myMonth2 = otodoke.getMonth() + 1;
    myDate2  = otodoke.getDate();
    myDay2   = otodoke.getDay();
    
    myMonth2 = '0'+ myMonth2;
    myMonth2 = myMonth2.slice(-2);
    myDate2  = '0' + myDate2;
    myDate2  = myDate2.slice(-2);
    
    return dateFormat(myMonth2,myDate2,myYear2,w);  
  } 
}

function dateFormat (month, date, week, w) {
  if (w == 1) {
    return myYear2+"/"+month+"/"+date;
  } else {
    return month+"月"+date+"日";
  }
}

let hiduke = document.getElementById("hizuke");
let hiduke2 = document.getElementById("hizuke2");
if(hiduke){
  hiduke.textContent = dispDate2W (0, 13, 0);
}
if(hiduke2){
  hiduke2.textContent = dispDate2W (0, 13, 1);
}

let classbut = document.getElementsByClassName('quick-product__btn');
if(classbut){
  classbut = Array.from(classbut);
  classbut.forEach(function(target) {
    target.addEventListener('click', function (){
      setTimeout(function(){
        let day = dispDate2W (0, 13,0);        
        let hiduke = document.getElementsByClassName("hizuke");

        let otodokeElements = document.querySelectorAll('.otodoke_show');
        otodokeElements.forEach(function(element) {
          element.style.display = 'none'; // 要素を非表示にする
        });
        
        hiduke = Array.from(hiduke);           
        hiduke.forEach(function (hiz) {
          hiz.textContent = day;
        });
      },1000);   
    });
  });
}

let prefecture = document.getElementById("prefecture");
prefecture.addEventListener('change', function (){
  let selectedPrefectureValue = prefecture.value;
  hiduke2.textContent = dispDate2W(0, 13, selectedPrefectureValue);
});
